import React from "react";
import Mobile from "./Mobile";
import Desktop from "./Desktop";
import styles from "./heroSection.module.scss";

const HeroSection = ({ heroSectionData, future_ready }) => {
  return (
    <div className={styles.main_container}>
      <div className={styles.mobile_container}>
        <Mobile heroSectionData={heroSectionData} future_ready={future_ready} />
      </div>

      <div className={styles.desktop_container}>
        <Desktop heroSectionData={heroSectionData} />
      </div>
    </div>
  );
};

export default HeroSection;
